import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './comp/global.css';
import App from './App';
import { LoadingProvider } from './comp/LoadingOverlay/LoadingContext';
import GlobalLoading from './comp/LoadingOverlay/GlobalLoading';
import { WebStorageStateStore } from 'oidc-client-ts';

const cognitoAuthConfig = {
  authority: "https://cognito-idp.ap-northeast-1.amazonaws.com/ap-northeast-1_8W9oDbMlJ",
  client_id: "552kv96pvidbnc93pvqntovvp0",
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  //redirect_uri: "http://localhost:3000/",
  response_type: "code",
  scope: "email openid profile",
  //prompt: "login",
  //クーポンが切れる前にクーポンを更新
  automaticSilentRenew: true,
  //ユーザーのクレーム（プロフィール情報）を取得・マージする
  loadUserInfo: true,
  userStore: new WebStorageStateStore({
    store: window.sessionStorage,
  }),
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// AuthProvider でラップすることで、App 配下の全ページで useAuth() により Cognito 認証情報を参照可能
root.render(
  <React.StrictMode>
    <AuthProvider
      {...cognitoAuthConfig}
      onSigninCallback={() => {
        // 認証コードや state 付きの URL を、通常のパスに書き換える
        window.history.replaceState({}, document.title, window.location.pathname);
      }}
    >
      <BrowserRouter>
        <LoadingProvider>
          <GlobalLoading />
          <App />
        </LoadingProvider>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
